// Static SRD label maps (skills, conditions) for UI rendering without a roundtrip.
export const SKILL_LABELS: Record<string, string> = {
  acrobatics: "Acrobatics",
  "animal-handling": "Animal Handling",
  arcana: "Arcana",
  athletics: "Athletics",
  deception: "Deception",
  history: "History",
  insight: "Insight",
  intimidation: "Intimidation",
  investigation: "Investigation",
  medicine: "Medicine",
  nature: "Nature",
  perception: "Perception",
  performance: "Performance",
  persuasion: "Persuasion",
  religion: "Religion",
  "sleight-of-hand": "Sleight of Hand",
  stealth: "Stealth",
  survival: "Survival",
};

export const SKILL_ABILITY: Record<string, string> = {
  acrobatics: "dex", "animal-handling": "wis", arcana: "int", athletics: "str",
  deception: "cha", history: "int", insight: "wis", intimidation: "cha",
  investigation: "int", medicine: "wis", nature: "int", perception: "wis",
  performance: "cha", persuasion: "cha", religion: "int", "sleight-of-hand": "dex",
  stealth: "dex", survival: "wis",
};

// Short blurbs of what each skill covers, shown when a skill row is expanded.
export const SKILL_DESC: Record<string, string> = {
  acrobatics: "Keep your balance, tumble, flip, and stay upright on tricky ground.",
  "animal-handling": "Calm, read, or handle a beast, and sense its intentions.",
  arcana: "Recall lore about spells, magic items, planes, and eldritch symbols.",
  athletics: "Climb, jump, swim, grapple, and shove through sheer physical effort.",
  deception: "Convincingly mislead — a lie, a disguise, a bluff, a false face.",
  history: "Recall past events, legends, kingdoms, wars, and ancient peoples.",
  insight: "Read a creature's true intentions, mood, or the lie behind its words.",
  intimidation: "Sway someone through threats, hostile shows of force, or menace.",
  investigation: "Deduce from clues, spot hidden details, and reason out how things work.",
  medicine: "Stabilize the dying and diagnose illness, poison, or injury.",
  nature: "Recall lore of terrain, plants, animals, weather, and natural cycles.",
  perception: "Notice things — spot, hear, or otherwise sense what's around you.",
  performance: "Delight or command an audience with music, dance, acting, or oratory.",
  persuasion: "Influence others in good faith — tact, grace, and honest appeal.",
  religion: "Recall lore of gods, rites, holy symbols, and the undead's ways.",
  "sleight-of-hand": "Pick pockets, palm objects, plant items, and other deft trickery.",
  stealth: "Move unseen and unheard — hide, sneak, and slip past notice.",
  survival: "Track, forage, navigate the wilds, and read weather and terrain.",
};

export const DM_STYLE_BLURB: Record<string, string> = {
  balanced: "A fair mix of danger, wonder, and wit.",
  gritty: "Harsh, grounded, consequences bite.",
  heroic: "Cinematic, sweeping, larger than life.",
  comedic: "Light, irreverent, quick with a joke.",
  horror: "Dread, tension, the dark pressing in.",
};

export const COMPENDIUM_TABS: { kind: import("./../lib/types").CompendiumKind; label: string }[] = [
  { kind: "spells", label: "Spells" },
  { kind: "monsters", label: "Monsters" },
  { kind: "magic-items", label: "Magic Items" },
  { kind: "equipment", label: "Equipment" },
  { kind: "conditions", label: "Conditions" },
  { kind: "rule-sections", label: "Rules" },
];

// Standard array values for assignment.
export const STANDARD_ARRAY = [15, 14, 13, 12, 10, 8];
